import React, { useEffect, useState, useRef } from "react";
import { Form, Input, Button, Card, Select, Row, Col } from "antd";
import { FaTools } from "react-icons/fa";
import { AddAddress, stateList } from "../../../services/Cart";
import { checkUserExists, RegisterNewUser } from "../../../services/Auth";
import { showSnackbar } from "../../../comopnents/snackbar";
import { getProfessions } from "../../../services/Spares";

const { Option } = Select;

const CreateServiceCenter = () => {
  const [form] = Form.useForm();
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [error, setError] = useState("");
  const [adding, setAdding] = useState(false);
  const [profloading, setProfLoading] = useState(false);
  const [professions, setProfessions] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [statecode, setstateCode] = useState('')
  const [formErrors, setFormErrors] = useState({});
  const [mailerror, setmailError] = useState("");

  const onRegister = async (data) => {
     console.log("🔥🔥 ONREGISTER CALLED", data);

    console.log("registering", data, professions.find((e) => data.profession === e.name)?.profession)
    setLoading(true);
    try {
      const payload = {
        first_name: data.first_name,
        username: data.email,
        firmname: data.firmname,
        email: data.email,
        mobile: data.mobile,
        password: '123456',
        usertype: "Service Center",
        module_assign: "0",
        extra2: professions.find((e) => data.profession === e.name)?.profession,
      };

      const res = await RegisterNewUser(payload);
      if (res?.status === 200)
        console.log("id", res.data.id)
      handleAddAddress(data, res.data.id)
    } catch {
      setError("Registration failed");
    } finally {
      setLoading(false);
    }
  };
  const onFinish = (values) => {
    // onRegister(values)
    console.log("Service Center Data:", values);
    form.resetFields();
  };


  useEffect(() => {
    loadProf();
  }, []);

  const loadProf = async () => {
    try {
      setProfLoading(true);
      const res = await getProfessions();
      console.log("prof", res.data.data);
      setProfessions(res.data.data || []);
    } catch (e) {
      console.error("Error loading product spares:", e);
    } finally {
      setProfLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoadingStates(true);
    try {
      const response = await stateList();
      console.log("Full API response:", response.data.List);
      setStates(response.data?.List)
      if (response.data?.List?.length === 0) {
        console.warn("No states found in the response");
        showSnackbar("No states available", "info");
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      showSnackbar("Failed to load states", "error");
    } finally {
      setLoadingStates(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);
const emailDebounceRef = useRef(null);
const mobileDebounceRef = useRef(null); 
  const debounceRef = useRef(null);
const validateUserField = (value, field) => {
  return new Promise((resolve, reject) => {
    if (!value) {
      resolve();
      return;
    }

    const debounceRef =
      field === "Email"
        ? emailDebounceRef
        : mobileDebounceRef;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const res = await checkUserExists({ param: value });

        console.log(`${field}: checkUserExists response`, res);

        if (res.status === 200) {
          reject(`${field} already exists`);
          return;
        }

        resolve();

      } catch (err) {
        console.log(
          `${field}: API ERROR`,
          err?.response?.status
        );

        if (
          err?.response?.status === 404 ||
          err?.response?.status === 409
        ) {
          resolve();
          return;
        }

        reject("Unable to validate. Try again later.");
      }
    }, 500);
  });
};


  // ---------------- HANDLE ADD ADDRESS ----------------
  const handleAddAddress = async (data, id) => {

    setAdding(true);
    try {
      const response = await AddAddress({
        addressType: "BILL",
        altphone: data.altphone,
        area: data.area,
        city: data.city,
        country: "India",
        customerid: id,
        email: data.email,
        flathouse: data.flathouse,
        gstno: data.gstno || "",
        landmark: data.landmark,
        name: data.first_name,
        phone: data.mobile,
        pincode: data.pincode,
        state: data.state,
        statecode: statecode,
        stateid: Number(statecode),
        type: data.type,
        useSameAddressForBilling: true,
      });

      console.log("Add address response:", response);

      if (
        response &&
        (response.status === 200 ||
          response.status === 201 ||
          response.success === true)
      )
        showSnackbar("success", "User Registered Successfully");
      onFinish(data)
    } catch (err) {
      console.error("Add address failed:", err);
      showSnackbar("Failed to add address", "error");
    } finally {
      setAdding(false);
    }
  };

  return (
    <Card
      title={
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <FaTools /> Create Service Center
        </span>
      }
      style={{ maxWidth: 900, margin: "20px auto" }}
     >
      <Form form={form} layout="vertical" onFinish={onRegister}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="first_name"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input placeholder="Enter  name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Firm Name"
              name="firmname"
              rules={[{ required: true, message: "Required" }]}
            >
              <Input placeholder="Enter Firm name" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter email" },
                { type: "email", message: "Enter a valid email" },
                {
                  validator: (_, value) => validateUserField(value, "Email"),
                },
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Mobile"
              name="mobile"
              rules={[
                { required: true, message: "Enter mobile number" },
                { pattern: /^[6-9]\d{9}$/, message: "Enter a valid 10-digit mobile number" },
                {
                  validator: (_, value) => validateUserField(value, "Mobile"),
                },
              ]}
            >
              <Input placeholder="Enter mobile number" maxLength={10} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>

          <Col span={12}>
            <Form.Item
              label="Profession"
              name="profession"
              rules={[{ required: true, message: "Required" }]}
            >
              <Select placeholder="Select Profession">
                {professions.map((p) => (
                  <Option key={p.id} value={p.name}>
                    {p.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Alternate Number (optional)"
              name="altphone"
            // rules={[{ required: true, message: "Alternate number is required" }]}
            >
              <Input placeholder="Alternate number" maxLength={10} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Flat/House No."
          name="flathouse"
          rules={[{ required: true, message: "House number is required" }]}
        >
          <Input placeholder="House number, building name" />
        </Form.Item>

        <Form.Item
          label="Area / Street"
          name="area"
          rules={[{ required: true, message: "Area is required" }]}
        >
          <Input placeholder="Area, street, sector, village" />
        </Form.Item>

        <Form.Item
          label="Landmark"
          name="landmark"
          rules={[{ required: true, message: "Landmark is required" }]}
        >
          <Input placeholder="Nearby landmark" />
        </Form.Item>

        <Row gutter={16}>o 
          <Col span={12}>
            <Form.Item
              label="City"
              name="city"
              rules={[{ required: true, message: "City is required" }]}
            >
              <Input placeholder="City" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="State"
              name="state"
              rules={[{ required: true, message: "State is required" }]}
            >
              <Select placeholder="Select State">
                {states
                  .sort((a, b) => a.statename.localeCompare(b.statename))
                  .map((s) => (
                    <Select.Option key={s.id} value={s.statename}>
                      {s.statename}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Pincode"
              name="pincode"
              rules={[
                { required: true, message: "Pincode is required" },
                { pattern: /^[1-9][0-9]{5}$/, message: "Enter valid pincode" },
              ]}
            >
              <Input placeholder="6-digit pincode" maxLength={6} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="GST Number"
              name="gstno"
              rules={[
                {
                  pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                  message: "Enter a valid GST number",
                },
              ]}
            >
              <Input placeholder="GST number (if applicable)" />
            </Form.Item></Col>
        </Row>

        <Form.Item>
           <Button
            type="primary"
            htmlType="submit"
            block
            loading={adding || loading}
          >
            Register
          </Button>
        </Form.Item>
      </Form>
    </Card>
          
  );
};

export default CreateServiceCenter;